<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-textarea
				browser-autocomplete="off"
				v-if="schema.min && !schema.max" v-model="value"
				:key="autogrowHack"
				:readonly="disabled"
				rows="1"
				:maxlength="maxTextAreaLength"
				:rules="[v => (v === undefined || v === '' || (v && v.length < maxTextAreaLength)) || 'Wyczerpano limit znaków']"
				auto-grow
				aria-label="label for text"/>
			<v-textarea v-else v-model="value"
				browser-autocomplete="off"
				:key="autogrowHack"
				:readonly="disabled"
				rows="1"
				:counter="schema.max"
				:rules="[v => (v === undefined || v === '' || (v && v.length < (schema.max ? schema.max : maxTextAreaLength))) || 'Wyczerpano limit znaków']"
				:maxlength="schema.max ? schema.max : maxTextAreaLength"
				auto-grow
				aria-label="label for text"/>
			<div class="div-for-print">{{value}}</div>
		</v-layout>
	</v-container>
</template>

<script>
	import {abstractField} from 'vue-form-generator';

	export default {
		name: 'customTextArea',

    mixins: [abstractField],

		data () {
			return {
				autogrowHack: false,
				timerId: undefined,
        maxTextAreaLength: 32767,
			};
		},

		created () {
			window.addEventListener("resize", this.rerender);
		},

		destroyed () {
			window.removeEventListener("resize", this.rerender);
		},

		methods: {
			rerender () {
				if (this.timerId) {
					clearTimeout(this.timerId);
				}
				this.timerId = setTimeout(() => {
					this.autogrowHack = !this.autogrowHack;
					this.timerId = null;
				}, 300);
			},
		},
	};
</script>

<style scoped>

</style>
